import {types, flow} from 'mobx-state-tree';
import AirbnbListingModel from '../AirbnbListingModel';
import * as api from '../../services/api';

const AirbnbListingDetailModel = types
  .model('AirbnbListingDetailModel', {
    isLoading: types.optional(types.boolean, false),
    listing: types.maybe(AirbnbListingModel)
  })
  .actions(self => ({
    getListing: flow(function*(listingId: number) {
      self.isLoading = true;
      const response = yield api.getAirbnbListing(listingId);
      if (response && response.status === 200 && response.data) {
        const listing = response.data.listing;
        if (!listing.bedrooms) {
          listing.bedrooms = 1;
        }
        self.listing = response.data.listing;
      }

      self.isLoading = false;
    })
  }));

export type AirbnbListingDetailModelType = typeof AirbnbListingDetailModel.Type;
export default AirbnbListingDetailModel;



// WEBPACK FOOTER //
// ./src/models/AirbnbListingDetailModel/AirbnbListingDetailModel.ts